var _path, _path2, _path3, _path4, _path5;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumOfQuestions(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50065 12.8346C3.19123 12.8346 2.89449 12.7117 2.67569 12.4929C2.4569 12.2741 2.33398 11.9774 2.33398 11.668V2.33464C2.33398 2.02522 2.4569 1.72847 2.67569 1.50968C2.89449 1.29089 3.19123 1.16797 3.50065 1.16797H8.16732C8.35197 1.16767 8.53487 1.20391 8.70546 1.27459C8.87605 1.34527 9.03098 1.449 9.16132 1.5798L11.2543 3.6728C11.3855 3.80318 11.4895 3.95826 11.5604 4.12906C11.6313 4.29987 11.6676 4.48304 11.6673 4.66797V11.668C11.6673 11.9774 11.5444 12.2741 11.3256 12.4929C11.1068 12.7117 10.8101 12.8346 10.5007 12.8346H3.50065Z",
    stroke: "#4A5464",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16602 1.16797V4.08464C8.16602 4.23934 8.22747 4.38772 8.33687 4.49711C8.44627 4.60651 8.59464 4.66797 8.74935 4.66797H11.666",
    stroke: "#4A5464",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83268 5.25H4.66602",
    stroke: "#4A5464",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33268 7.58203H4.66602",
    stroke: "#4A5464",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33268 9.91797H4.66602",
    stroke: "#4A5464",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumOfQuestions);
export default __webpack_public_path__ + "static/media/numOfQuestions.eb841511afb50bf642e6d741379ed1ca.svg";
export { ForwardRef as ReactComponent };